import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Input,
  FormGroup,
  Label,
  Badge,
} from "reactstrap";
import Select from "react-select";
import CloudRestroUsers from "../../../services/DatabaseService/CloudRestroUsers";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import { toast } from "react-toastify";
import BulkAddModal from "./component/BulkAddModal";

const OrganizationDevices = () => {
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [allOrganizations, setAllOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingOrgs, setLoadingOrgs] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [bulkAddModalOpen, setBulkAddModalOpen] = useState(false);

  const CustomOption = (props) => {
    const { data } = props;

    return (
      <div
        {...props.innerProps}
        className="px-3 py-2 d-flex justify-content-between align-items-center"
      >
        <div>
          <div style={{ fontWeight: 600 }}>
            {data.deviceName || "Unnamed Device"}
          </div>

          <small className="text-muted">{data.macId}</small>
        </div>

        <div>
          <Badge color="light" className="text-dark">
            {data.orgName}
          </Badge>
        </div>
      </div>
    );
  };

  //   const CustomSingleValue = ({ data }) => {
  //     return (
  //       <div className="bg-success">
  //         <div className="" style={{ fontWeight: 600 }}>
  //           {data.deviceName || "Unnamed Device"}
  //         </div>

  //         <small className="text-muted">{data.macId}</small>
  //       </div>
  //     );
  //   };
  // Fetch devices on mount
  useEffect(() => {
    fetchDevices();
    fetchAllOrganizations();
  }, []);

  // Fetch organizations when device is selected
  useEffect(() => {
    if (selectedDevice) {
      fetchOrganizations(selectedDevice.value);
    } else {
      setOrganizations([]);
    }
  }, [selectedDevice]);

  //   const fetchDevices = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await CloudRestroUsers.getWithDevices({ onlyWithDevices: true });
  //       console.log("🚀 ~ fetchDevices ~ response:", response)

  //       // Extract unique devices from the response
  //       const uniqueDevices = [];
  //       const deviceMap = new Map();

  //       response.forEach(org => {
  //         if (org.devices && Array.isArray(org.devices)) {
  //           org.devices.forEach(device => {
  //             if (!deviceMap.has(device.macId)) {
  //               deviceMap.set(device.macId, {
  //                 value: device.macId,
  //                 label: `${device.macId} - ${device.name || 'Unknown'}`,
  //                 device: device
  //               });
  //             }
  //           });
  //         }
  //       });

  //       setDevices(Array.from(deviceMap.values()));
  //     } catch (error) {
  //       console.error("Error fetching devices:", error);
  //       toast.error("Failed to load devices");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  const fetchDevices = async () => {
    setLoading(true);
    try {
      const response = await CloudRestroUsers.getWithDevices({
        onlyWithDevices: true,
      });

      const deviceMap = new Map();

      response.forEach((org) => {
        if (org.devices && Array.isArray(org.devices)) {
          org.devices.forEach((device) => {
            if (!device.macId) return;

            if (!deviceMap.has(device.macId)) {
              deviceMap.set(device.macId, {
                value: device.macId, // still used for dropdown
                label: device.deviceName || device.macId,
                deviceId: device.deviceId, // ⭐ IMPORTANT
                deviceName: device.deviceName,
                macId: device.macId,
                orgName: org.name,
                device,
              });
            }
          });
        }
      });

      setDevices(Array.from(deviceMap.values()));
    } catch (error) {
      console.error("Error fetching devices:", error);
      toast.error("Failed to load devices");
    } finally {
      setLoading(false);
    }
  };
  const fetchAllOrganizations = async () => {
    try {
      const response = await CloudRestroUsers.getWithDevices({
        onlyWithDevices: false,
      });
      setAllOrganizations(response);
    } catch (error) {
      console.error("Error fetching all organizations:", error);
    }
  };

  const fetchOrganizations = async (macId) => {
    setLoadingOrgs(true);
    try {
      const response = await CloudRestroUsers.getDeviceOrganizations(macId);
      console.log("🚀 ~ fetchOrganizations ~ response:", response);
      setOrganizations(response);
    } catch (error) {
      console.error("Error fetching organizations:", error);
      toast.error("Failed to load organizations");
      setOrganizations([]);
    } finally {
      setLoadingOrgs(false);
    }
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select organizations to delete");
      return;
    }

    if (
      !window.confirm(
        `Are you sure you want to remove ${selectedRows.length} organization(s) from this device?`,
      )
    ) {
      return;
    }

    try {
      const ids = selectedRows.map((row) => row.id);
      await CloudRestroUsers.bulkDelete(ids);
      toast.success(
        `Successfully removed ${selectedRows.length} organization(s)`,
      );

      // Refresh organizations list
      if (selectedDevice) {
        fetchOrganizations(selectedDevice.value);
      }
      setSelectedRows([]);
    } catch (error) {
      console.error("Error deleting organizations:", error);
      toast.error("Failed to delete organizations");
    }
  };

  const handleBulkAdd = () => {
    if (!selectedDevice) {
      toast.warning("Please select a device first");
      return;
    }
    setBulkAddModalOpen(true);
  };

  const handleBulkAddSuccess = () => {
    if (selectedDevice) {
      fetchOrganizations(selectedDevice.value);
    }
    setBulkAddModalOpen(false);
  };

  const filteredData = organizations.filter(
    (item) =>
      (item.name?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || "",
      ) ||
      (item.orgCode?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || "",
      ) ||
      (item.email?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || "",
      ) ||
      (item.address1?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || "",
      ),
  );

  const handleSelectedRowsChange = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const columns = [
    {
      name: "S.No",
      cell: (row, index) => index + 1,
      width: "70px",
      center: true,
    },
    {
      name: "Organization Name",
      selector: (row) => row.name,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <strong>{row.name}</strong>
          <br />
          <small className="text-muted">{row.orgCode}</small>
        </div>
      ),
    },
    {
      name: "Contact",
      selector: (row) => row.email,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <div>{row.email}</div>
          <small className="text-muted">{row.tel || row.contactNo}</small>
        </div>
      ),
    },
    {
      name: "Address",
      selector: (row) => row.address1,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div>
          {row.address1 && <div>{row.address1}</div>}
          {row.address2 && <small className="text-muted">{row.address2}</small>}
        </div>
      ),
    },
    {
      name: "Logo",
      width: "100px",
      center: true,
      cell: (row) =>
        row.logoPath || row.cloudR2Path ? (
          <Badge color="success" pill>
            <i className="bx bx-check"></i> Yes
          </Badge>
        ) : (
          <Badge color="secondary" pill>
            <i className="bx bx-x"></i> No
          </Badge>
        ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <h4 className="mb-0">Organization-Device Management</h4>
            <p className="text-muted">
              Manage organizations assigned to devices
            </p>
          </Col>
        </Row>

        {/* Device Selection */}
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader className="bg-light">
                <h5 className="mb-0">
                  <div className="d-flex align-content-center align-items-center">
                    <i className="bx bx-devices me-2"></i>Select Device
                  </div>
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={8}>
                    <FormGroup>
                      <Label>Device (MAC ID)</Label>
                      <Select
                        options={devices}
                        value={selectedDevice}
                        onChange={(device) => {
                          console.log("Selected Device:", device);
                          setSelectedDevice(device);
                        }}
                        placeholder="Select a device..."
                        isClearable
                        isLoading={loading}
                        components={{
                          Option: CustomOption,
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} className="d-flex align-items-end">
                    <FormGroup className="w-100">
                      <Button
                        color="primary"
                        block
                        onClick={handleBulkAdd}
                        disabled={!selectedDevice}
                      >
                        <i className="bx bx-plus me-2"></i>Add Organizations
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Organizations Table */}
        {selectedDevice && (
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="bg-light">
                  <Row className="align-items-center">
                    <Col md={6}>
                      <h5 className="mb-0">
                        <i className="bx bx-buildings me-2"></i>
                        Organizations ({filteredData.length})
                      </h5>
                    </Col>
                    <Col md={6} className="text-end">
                      <Button
                        color="danger"
                        size="sm"
                        onClick={handleBulkDelete}
                        disabled={selectedRows.length === 0 || loadingOrgs}
                      >
                        <i className="bx bx-trash me-2"></i>
                        Remove Selected ({selectedRows.length})
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Input
                        type="text"
                        placeholder="Search organizations..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                      />
                    </Col>
                  </Row>

                  {loadingOrgs ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "200px" }}
                    >
                      <Triangle
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="triangle-loading"
                        visible={true}
                      />
                    </div>
                  ) : (
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination
                      selectableRows
                      onSelectedRowsChange={handleSelectedRowsChange}
                      highlightOnHover
                      pointerOnHover
                      responsive
                      striped
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* Bulk Add Modal */}
        <BulkAddModal
          isOpen={bulkAddModalOpen}
          toggle={() => setBulkAddModalOpen(false)}
          deviceId={selectedDevice?.deviceId}
          allOrganizations={allOrganizations}
          currentOrganizations={organizations}
          onSuccess={handleBulkAddSuccess}
        />
      </Container>
    </div>
  );
};

export default OrganizationDevices;
